import { z } from 'zod';

export const TransactionVestingTermShape = z.object({
	vestingTermId: z
		.string()
		.nullable()
		.refine((vestingTermId) => !!vestingTermId),
	vestingStartDate: z.date().nullable(),
});

export type TransactionVestingTermFormValues = z.infer<typeof TransactionVestingTermShape>;
